var map = {
	"./+examples/examples/signalr/signalr.module": [
		"./src/app/+examples/examples/signalr/signalr.module.ts",
		"examples-examples-signalr-signalr-module"
	],
	"./page-layout-card-tabbed/page-layout-card-tabbed.module": [
		"./src/app/pages/page-layouts/page-layout-card-tabbed/page-layout-card-tabbed.module.ts",
		"common",
		"page-layout-card-tabbed-page-layout-card-tabbed-module"
	],
	"./page-layout-card/page-layout-card.module": [
		"./src/app/pages/page-layouts/page-layout-card/page-layout-card.module.ts",
		"common",
		"page-layout-card-page-layout-card-module"
	],
	"./page-layout-simple-tabbed/page-layout-simple-tabbed.module": [
		"./src/app/pages/page-layouts/page-layout-simple-tabbed/page-layout-simple-tabbed.module.ts",
		"common",
		"page-layout-simple-tabbed-page-layout-simple-tabbed-module"
	],
	"./page-layout-simple/page-layout-simple.module": [
		"./src/app/pages/page-layouts/page-layout-simple/page-layout-simple.module.ts",
		"common",
		"page-layout-simple-page-layout-simple-module"
	],
	"./pages/apps/calendar/calendar.module": [
		"./src/app/pages/apps/calendar/calendar.module.ts",
		"pages-apps-calendar-calendar-module"
	],
	"./pages/apps/chat/chat.module": [
		"./src/app/pages/apps/chat/chat.module.ts",
		"pages-apps-chat-chat-module"
	],
	"./pages/apps/inbox/inbox.module": [
		"./src/app/pages/apps/inbox/inbox.module.ts",
		"default~pages-apps-inbox-inbox-module~pages-editor-editor-module",
		"pages-apps-inbox-inbox-module"
	],
	"./pages/authentication/confirm-email/confirm-email.module": [
		"./src/app/pages/authentication/confirm-email/confirm-email.module.ts",
		"common",
		"pages-authentication-confirm-email-confirm-email-module"
	],
	"./pages/authentication/forgot-password/forgot-password.module": [
		"./src/app/pages/authentication/forgot-password/forgot-password.module.ts",
		"common",
		"pages-authentication-forgot-password-forgot-password-module"
	],
	"./pages/authentication/login/login.module": [
		"./src/app/pages/authentication/login/login.module.ts",
		"common",
		"pages-authentication-login-login-module"
	],
	"./pages/authentication/login2/login2.module": [
		"./src/app/pages/authentication/login2/login2.module.ts",
		"common",
		"pages-authentication-login2-login2-module"
	],
	"./pages/authentication/register/register.module": [
		"./src/app/pages/authentication/register/register.module.ts",
		"pages-authentication-register-register-module"
	],
	"./pages/authentication/reset-password/reset-password.module": [
		"./src/app/pages/authentication/reset-password/reset-password.module.ts",
		"common",
		"pages-authentication-reset-password-reset-password-module"
	],
	"./pages/authentication/set-password/set-password.module": [
		"./src/app/pages/authentication/set-password/set-password.module.ts",
		"common",
		"pages-authentication-set-password-set-password-module"
	],
	"./pages/authentication/update-password/update-password.module": [
		"./src/app/pages/authentication/update-password/update-password.module.ts",
		"common",
		"pages-authentication-update-password-update-password-module"
	],
	"./pages/banaozel/banaozel.module": [
		"./src/app/pages/banaozel/banaozel.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"default~pages-banaozel-banaozel-module~pages-drag-and-drop-drag-and-drop-module",
		"pages-banaozel-banaozel-module"
	],
	"./pages/blank/blank.module": [
		"./src/app/pages/blank/blank.module.ts",
		"pages-blank-blank-module"
	],
	"./pages/coming-soon/coming-soon.module": [
		"./src/app/pages/coming-soon/coming-soon.module.ts",
		"pages-coming-soon-coming-soon-module"
	],
	"./pages/company-pages/company/company-all-in-one-table.module": [
		"./src/app/pages/company-pages/company/company-all-in-one-table.module.ts"
	],
	"./pages/components/components.module": [
		"./src/app/pages/components/components.module.ts"
	],
	"./pages/customer/customer.module": [
		"./src/app/pages/customer/customer.module.ts",
		"pages-customer-customer-module"
	],
	"./pages/customer/customerdetail/customer-detail.module": [
		"./src/app/pages/customer/customerdetail/customer-detail.module.ts",
		"pages-customer-customerdetail-customer-detail-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"pages-dashboard-dashboard-module"
	],
	"./pages/documents/category/document-category.module": [
		"./src/app/pages/documents/category/document-category.module.ts",
		"pages-documents-category-document-category-module"
	],
	"./pages/documents/directory/document-directory-detail/document-directory-detail.module": [
		"./src/app/pages/documents/directory/document-directory-detail/document-directory-detail.module.ts",
		"pages-documents-directory-document-directory-detail-document-directory-detail-module"
	],
	"./pages/documents/directory/document-directory.module": [
		"./src/app/pages/documents/directory/document-directory.module.ts",
		"pages-documents-directory-document-directory-module"
	],
	"./pages/documents/directorylist/directorylist.module": [
		"./src/app/pages/documents/directorylist/directorylist.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"pages-documents-directorylist-directorylist-module"
	],
	"./pages/documents/documentlist/documentlist.module": [
		"./src/app/pages/documents/documentlist/documentlist.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"pages-documents-documentlist-documentlist-module"
	],
	"./pages/documents/settings/document-settings.module": [
		"./src/app/pages/documents/settings/document-settings.module.ts",
		"pages-documents-settings-document-settings-module"
	],
	"./pages/drag-and-drop/drag-and-drop.module": [
		"./src/app/pages/drag-and-drop/drag-and-drop.module.ts",
		"default~pages-banaozel-banaozel-module~pages-drag-and-drop-drag-and-drop-module",
		"pages-drag-and-drop-drag-and-drop-module"
	],
	"./pages/editor/editor.module": [
		"./src/app/pages/editor/editor.module.ts",
		"default~pages-apps-inbox-inbox-module~pages-editor-editor-module",
		"common",
		"pages-editor-editor-module"
	],
	"./pages/forms/form-elements/form-elements.module": [
		"./src/app/pages/forms/form-elements/form-elements.module.ts"
	],
	"./pages/forms/form-wizard/form-wizard.module": [
		"./src/app/pages/forms/form-wizard/form-wizard.module.ts",
		"common",
		"pages-forms-form-wizard-form-wizard-module"
	],
	"./pages/icons/icons.module": [
		"./src/app/pages/icons/icons.module.ts",
		"pages-icons-icons-module"
	],
	"./pages/issue/issue-detail/issue-detail.module": [
		"./src/app/pages/issue/issue-detail/issue-detail.module.ts"
	],
	"./pages/issue/issue-list/issue-list.module": [
		"./src/app/pages/issue/issue-list/issue-list.module.ts"
	],
	"./pages/level5/level5.module": [
		"./src/app/pages/level5/level5.module.ts",
		"pages-level5-level5-module"
	],
	"./pages/maps/google-maps/google-maps.module": [
		"./src/app/pages/maps/google-maps/google-maps.module.ts",
		"pages-maps-google-maps-google-maps-module"
	],
	"./pages/notificationsettings/notificationsettings.module": [
		"./src/app/pages/notificationsettings/notificationsettings.module.ts",
		"pages-notificationsettings-notificationsettings-module"
	],
	"./pages/page-layouts/page-layouts.module": [
		"./src/app/pages/page-layouts/page-layouts.module.ts",
		"pages-page-layouts-page-layouts-module"
	],
	"./pages/profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"pages-profile-profile-module"
	],
	"./pages/projectmodule/project-detail/project-detail.module": [
		"./src/app/pages/projectmodule/project-detail/project-detail.module.ts",
		"pages-projectmodule-project-detail-project-detail-module"
	],
	"./pages/projectmodule/projectlist.module": [
		"./src/app/pages/projectmodule/projectlist.module.ts",
		"pages-projectmodule-projectlist-module"
	],
	"./pages/projectsettings/projectsettings.module": [
		"./src/app/pages/projectsettings/projectsettings.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"pages-projectsettings-projectsettings-module"
	],
	"./pages/reports/issuereportassignedsummary/issue-assigned-summary.module": [
		"./src/app/pages/reports/issuereportassignedsummary/issue-assigned-summary.module.ts",
		"pages-reports-issuereportassignedsummary-issue-assigned-summary-module"
	],
	"./pages/reports/issuereportassignedusersummary/issue-assigned-user-summary.module": [
		"./src/app/pages/reports/issuereportassignedusersummary/issue-assigned-user-summary.module.ts",
		"pages-reports-issuereportassignedusersummary-issue-assigned-user-summary-module"
	],
	"./pages/reports/issuereports/issue-project.module": [
		"./src/app/pages/reports/issuereports/issue-project.module.ts",
		"pages-reports-issuereports-issue-project-module"
	],
	"./pages/reports/issuereportsummary/issue-project-summary.module": [
		"./src/app/pages/reports/issuereportsummary/issue-project-summary.module.ts",
		"pages-reports-issuereportsummary-issue-project-summary-module"
	],
	"./pages/reports/workingtime/working-time.module": [
		"./src/app/pages/reports/workingtime/working-time.module.ts",
		"pages-reports-workingtime-working-time-module"
	],
	"./pages/support/customer-issue/customer-issue-detail/customer-issue-detail.module": [
		"./src/app/pages/support/customer-issue/customer-issue-detail/customer-issue-detail.module.ts",
		"pages-support-customer-issue-customer-issue-detail-customer-issue-detail-module"
	],
	"./pages/support/customer-issue/customer-issue.module": [
		"./src/app/pages/support/customer-issue/customer-issue.module.ts",
		"pages-support-customer-issue-customer-issue-module"
	],
	"./pages/support/customer-support-entry/customer-support-entry.module": [
		"./src/app/pages/support/customer-support-entry/customer-support-entry.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"common",
		"pages-support-customer-support-entry-customer-support-entry-module"
	],
	"./pages/support/public-issue/public-issue-detail/public-issue-detail.module": [
		"./src/app/pages/support/public-issue/public-issue-detail/public-issue-detail.module.ts",
		"pages-support-public-issue-public-issue-detail-public-issue-detail-module"
	],
	"./pages/support/public-issue/public-issue.module": [
		"./src/app/pages/support/public-issue/public-issue.module.ts",
		"pages-support-public-issue-public-issue-module"
	],
	"./pages/support/public-support-entry/public-support-entry.module": [
		"./src/app/pages/support/public-support-entry/public-support-entry.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"common",
		"pages-support-public-support-entry-public-support-entry-module"
	],
	"./pages/support/public-support-manage/public-support-manage.module": [
		"./src/app/pages/support/public-support-manage/public-support-manage.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"pages-support-public-support-manage-public-support-manage-module"
	],
	"./pages/support/support-form-setting/support-form-setting.module": [
		"./src/app/pages/support/support-form-setting/support-form-setting.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"pages-support-support-form-setting-support-form-setting-module"
	],
	"./pages/support/support-type/support-type.module": [
		"./src/app/pages/support/support-type/support-type.module.ts",
		"pages-support-support-type-support-type-module"
	],
	"./pages/tables/all-in-one-table/all-in-one-table.module": [
		"./src/app/pages/tables/all-in-one-table/all-in-one-table.module.ts",
		"pages-tables-all-in-one-table-all-in-one-table-module"
	],
	"./pages/usergroups/usergroups.module": [
		"./src/app/pages/usergroups/usergroups.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"pages-usergroups-usergroups-module"
	],
	"./pages/users/users.module": [
		"./src/app/pages/users/users.module.ts",
		"default~pages-banaozel-banaozel-module~pages-documents-directorylist-directorylist-module~pages-docu~e8c52e45",
		"common",
		"pages-users-users-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;